export default {"src":"/_next/static/media/widget.bdccac61.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};